import { BulkSpreadsheet, parseBool, parseInt10, type BulkColumn } from '../shared/BulkSpreadsheet';
import { stockService } from '@kss/api';
import type { StockCreate } from '@kss/api';
import { loadProductOptions, loadStoreOptions, loadWarehouseOptions } from '../shared/formLoaders';

const columns: BulkColumn<StockCreate>[] = [
  { key: 'productId', header: 'Product', required: true, dataType: 'lookup', loadOptions: loadProductOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'warehouseId', header: 'Warehouse', dataType: 'lookup', loadOptions: loadWarehouseOptions },
  { key: 'quantity', header: 'Qty', required: true, dataType: 'integer', parse: parseInt10 as never, sample: '100' },
  { key: 'reorderLevel', header: 'Reorder', dataType: 'integer', parse: parseInt10 as never, sample: '10' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkStock() {
  return (
    <BulkSpreadsheet<StockCreate> title="Bulk import stock" entityLabel="stock entry" backPath="/panel/stock" columns={columns} module="Stock"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, quantity: Number(r.quantity ?? 0), isActive: r.isActive ?? true }));
        const created = await stockService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
